<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Lung Specific Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-4 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="secondarySpecification"
              class="secondarySpecification"
              disabled
              label="Secondary Specification"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="secondarySpecificationOATS"
              class="secondarySpecification"
              disabled
              label="Secondary Specification"
              :class="{ highlightField: isDifferent(secondarySpecification, secondarySpecificationOATS) }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="predictedTLC"
              disabled
              label="Predicted TLC"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="predictedTLCOATS"
              disabled
              label="Predicted TLC"
              :class="{ highlightField: isDifferent(predictedTLC, predictedTLCOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="comments"
              class="comments"
              disabled
              label="COMMENTS-EMR"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="commentsOATS"
              class="comments"
              disabled
              label="COMMENTS-OATS"
              :class="{ highlightField: isDifferent(comments, commentsOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="actualTLC"
              disabled
              label="Actual TLC "
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="actualTLCOATS"
              disabled
              label="Actual TLC "
              :class="{ highlightField: isDifferent(actualTLC, actualTLCOATS) }"
            />
          </div>
        </div>
    
        
   
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="FEV1"
              disabled
              label="FEV1"
            />
          </div> 

          <div class="col-2">
            <ADSTextInput
              v-model="FEV1OATS"
              disabled
              label="FEV1"
              :class="{ highlightField: isDifferent(FEV1, FEV1OATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="predictedFVC"
              disabled
              label="Predicted FVC"
            />
          </div> 

          <div class="col-2">
            <ADSTextInput
              v-model="predictedFVCOATS"
              disabled
              label="Predicted FVC"
              :class="{ highlightField: isDifferent(predictedFVC, predictedFVCOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="perfusionRight"
              disabled
              label="Perfusion Right"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="perfusionRightOATS"
              disabled
              label="Perfusion Right"
              :class="{ highlightField: isDifferent(perfusionRight, perfusionRightOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="perfusionLeft"
              disabled
              label="Perfusion Left"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="perfusionLeftOATS"
              disabled
              label="Perfusion Left"
              :class="{ highlightField: isDifferent(perfusionLeft, perfusionLeftOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="estRVPressSYS"
              disabled
              label="Estimated RV Systolic Pressure"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="estRVPressSYSOATS"
              disabled
              label="Estimated RV Systolic Pressure"
              :class="{ highlightField: isDifferent(estRVPressSYS, estRVPressSYSOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="systolicPAPressure"
              disabled
              label="Systolic PA Pressure"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="systolicPAPressureOATS"
              disabled
              label="Systolic PA Pressure"
              :class="{ highlightField: isDifferent(systolicPAPressure, systolicPAPressureOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="diastolicPAPressure"
              disabled
              label="Diastolic PA Pressure"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="diastolicPAPressureOATS"
              disabled
              label="Diastolic PA Pressure"
              :class="{ highlightField: isDifferent(diastolicPAPressure, diastolicPAPressureOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="echoDate"
              disabled
              label="Echo Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="echoDateOATS"
              disabled
              label="Echo Date"
              :class="{ highlightField: isDifferent(echoDate, echoDateOATS) }"
            />
          </div>
        </div>
        
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="meanPAPressure"
              disabled
              label="Mean PA Pressure"
            />
          </div>
          
          <div class="col-4">
            <ADSTextInput
              v-model="meanPAPressureOATS"
              disabled
              label="Mean PA Pressure"
              :class="{ highlightField: isDifferent(meanPAPressure, meanPAPressureOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="chestCTResults"
              class="chestCTResults"
              disabled
              label="Chest CT Results"
            />
          </div>
          
          <div class="col-4">
            <ADSTextInput
              v-model="chestCTResultsOATS"
              class="chestCTResults"
              disabled
              label="Chest CT Results"
              :class="{ highlightField: isDifferent(chestCTResults, chestCTResultsOATS) }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="echoComment"
              class="echoComment"
              disabled
              label="Echo Comment"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="echoCommentOATS"
              class="echoComment"
              disabled
              label="Echo Comment"
              :class="{ highlightField: isDifferent(echoComment, echoCommentOATS) }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="chestCTDate"
              disabled
              label="Chest CT Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="chestCTDateOATS"
              disabled
              label="Chest CT Date"
              :class="{ highlightField: isDifferent(chestCTDate, chestCTDateOATS) }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="las"
              disabled
              label="LAS"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="lasOATS"
              disabled
              label="LAS"
              :class="{ highlightField: isDifferent(las, lasOATS) }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="extraCorporealLifeSupport"
              disabled
              label="ECLS"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="extraCorporealLifeSupportOATS"
              disabled
              label="ECLS"
              :class="{ highlightField: isDifferent(extraCorporealLifeSupport, extraCorporealLifeSupportOATS) }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="extraCorporealLifeSupportComment"
              disabled
              label="ECLS Comment"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="extraCorporealLifeSupportCommentOATS"
              disabled
              label="ECLS Comment"
              :class="{ highlightField: isDifferent(extraCorporealLifeSupportComment, extraCorporealLifeSupportCommentOATS) }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="ventilator"
              disabled
              label="Ventilator"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="ventilatorOATS"
              disabled
              label="Ventilator"
              :class="{ highlightField: isDifferent(ventilator, ventilatorOATS) }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="ventilatorComment"
              disabled
              label="Ventilator Comment"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="ventilatorCommentOATS"
              disabled
              label="Ventilator Comment"
              :class="{ highlightField: isDifferent(ventilatorComment, ventilatorCommentOATS) }"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

/** Labels match TGLN `ValueConversions.SECONDARY_SPEC_CODE` (internal code -> external / display). */
const SECONDARY_SPEC_CODE_TO_LABEL = new Map( [
  [ '401', 'Lung - Both' ],
  [ '421', 'Lung - Either double or single' ],
  [ '423', 'Lung - Either double or single left' ],
  [ '422', 'Lung - Either double or single right' ],
  [ '402', 'Lung - Right' ],
  [ '403', 'Lung - Left' ],
  [ '411', 'Lung - Single' ],
  [ '433', 'Lung - Double or single prefer left' ],
  [ '432', 'Lung - Double or single prefer right' ],
] );

export default {
  name: "LungSpecificSectionDetailsEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      secondarySpecification: this.getSecondarySpecification( this.patientBundle ),
      secondarySpecificationOATS: this.getSecondarySpecificationOATS( this.patientBundleOATS ),
      predictedTLC: this.getPredictedTLC( this.patientBundle ),
      predictedTLCOATS: this.getPredictedTLCOATS( this.patientBundleOATS ),
      actualTLC: this.getActualTLC( this.patientBundle ),
      actualTLCOATS: this.getActualTLCOATS( this.patientBundleOATS ),
      FEV1: this.getFEV1( this.patientBundle ), 
      FEV1OATS: this.getFEV1OATS( this.patientBundleOATS ),
      predictedFVC: this.getPredictedFVC( this.patientBundle ), 
      predictedFVCOATS: this.getPredictedFVCOATS( this.patientBundleOATS ),
      comments: this.getComments( this.patientBundle ),
      commentsOATS: this.getCommentsOATS( this.patientBundleOATS ),
      perfusionRight: this.getPerfusionRight( this.patientBundle ),
      perfusionRightOATS: this.getPerfusionRightOATS( this.patientBundleOATS ),
      perfusionLeft: this.getPerfusionLeft( this.patientBundle ),
      perfusionLeftOATS: this.getPerfusionLeftOATS( this.patientBundleOATS ),
      estRVPressSYS: this.getESTRVPressSYS( this.patientBundle ),
      estRVPressSYSOATS: this.getESTRVPressSYSOATS( this.patientBundleOATS ),
      systolicPAPressure: this.getSystolicPAPressure( this.patientBundle ),
      systolicPAPressureOATS: this.getSystolicPAPressureOATS( this.patientBundleOATS ),
      diastolicPAPressure: this.getDiastolicPAPressure( this.patientBundle ),
      diastolicPAPressureOATS: this.getDiastolicPAPressureOATS( this.patientBundleOATS ),
      meanPAPressure: this.getMeanPAPressure( this.patientBundle ),
      meanPAPressureOATS: this.getMeanPAPressureOATS( this.patientBundleOATS ),
      echoComment: this.getEchoComment( this.patientBundle ),
      echoCommentOATS: this.getEchoCommentOATS( this.patientBundleOATS ),
      echoDate: this.getEchoDate( this.patientBundle ),
      echoDateOATS: this.getEchoDateOATS( this.patientBundleOATS ),
      chestCTResults: this.getChestCTResults( this.patientBundle ),
      chestCTResultsOATS: this.getChestCTResultsOATS( this.patientBundleOATS ),
      chestCTDate: this.getChestCTDate( this.patientBundle ),
      chestCTDateOATS: this.getChestCTDateOATS( this.patientBundleOATS ),
      las: this.getLAS( this.patientBundle ),
      lasOATS: this.getLASOATS( this.patientBundleOATS ),
      extraCorporealLifeSupport: this.getExtraCorporealLifeSupport( this.patientBundle ),
      extraCorporealLifeSupportOATS: this.getExtraCorporealLifeSupportOATS( this.patientBundleOATS ),
      extraCorporealLifeSupportComment: this.getExtraCorporealLifeSupportComment( this.patientBundle ),
      extraCorporealLifeSupportCommentOATS: this.getExtraCorporealLifeSupportCommentOATS( this.patientBundleOATS ),
      ventilator: this.getVentilator( this.patientBundle ),
      ventilatorOATS: this.getVentilatorOATS( this.patientBundleOATS ),
      ventilatorComment: this.getVentilatorComment( this.patientBundle ),
      ventilatorCommentOATS: this.getVentilatorCommentOATS( this.patientBundleOATS ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    isDifferent( a, b ) {
      return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
  },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) { 
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getSecondarySpecification( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8210' );
    },
    getSecondarySpecificationOATS( patientBundleOATS ) {
      const journeys = patientBundleOATS?.journeys?.filter( ( n ) =>
        n.organ_code === 4 && n.state !== 'cancelled' && n.state !== 'declined'
      );
      const code = journeys?.[ 0 ]?.organ_specific_details?.organ_specification_preference_code;
      if( code === null || code === undefined || code === '' ) {
        return null;
      }
      const key = String( code ).trim();
      return SECONDARY_SPEC_CODE_TO_LABEL.get( key ) ?? key;
    },
    getPredictedTLC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8213' );
    },
    getPredictedTLCOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.predicted_total_lung_capacity;
      }
    },
    getActualTLC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8214' );
    },
    getActualTLCOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.actual_total_lung_capacity;
      }
    },
    getFEV1( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8231' );
    },
    getFEV1OATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.actual_forced_expiratory_volume;
      }
    },
    getPredictedFVC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8230' );
    },
    getPredictedFVCOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.predicted_forced_vital_capacity;
      }
    },
    getComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8232' );
    },
    getCommentsOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].comments;
      }
    },
    getPerfusionRight( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8211' );
    },
    getPerfusionRightOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.perfusion_right;
      }
    },
    getPerfusionLeft( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8212' );
    },
    getPerfusionLeftOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.perfusion_left;
      }
    },
    getESTRVPressSYS( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8215' );
    },
    getESTRVPressSYSOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.estimated_right_ventricular_systolic_pressure;
      }
    },
    getSystolicPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8216' );
    },
    getSystolicPAPressureOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.pulmonary_artery_systolic_pressure;
      }
    },
    getDiastolicPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8217' );
    },
    getDiastolicPAPressureOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.pulmonary_artery_diastolic_pressure;
      }
    },
    getMeanPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8218' );
    },
    getMeanPAPressureOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.pulmonary_mean_arterial_pressure;
      }
    },
    getEchoComment( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8221' );
    },
    getEchoCommentOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.echocardiogram_comment;
      }
    },
    getEchoDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8220', 'valueDateTime' );
    },
    getEchoDateOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.echocardiogram_date;
      }
    },
    getChestCTResults( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8223' );
    },
    getChestCTResultsOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.chest_ct_scan_result;
      }
    },
    getChestCTDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8222', 'valueDateTime' );
    },
    getChestCTDateOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.chest_ct_scan_date;
      }
    },
    getLAS( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8219' );
    },
    getLASOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.lung_allocation_score;
      }
    },
    getExtraCorporealLifeSupport( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8226', 'valueBoolean' );
    },
    getExtraCorporealLifeSupportOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        const value = journey[ 0 ].organ_specific_details?.extra_corporeal_life_support;
        const normalized = String( value ?? '' ).trim().toLowerCase();
        if( normalized === 'y' ) {
          return true;
        }
        if( normalized === 'n' ) {
          return false;
        }
        return value;
      }
    },
    getExtraCorporealLifeSupportComment( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8227' );
    },
    getExtraCorporealLifeSupportCommentOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.extra_corporeal_life_support_comment;
      }
    },
    getVentilator( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8228', 'valueBoolean' );
    },
    getVentilatorOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        const value = journey[ 0 ].organ_specific_details?.ventilator;
        const normalized = String( value ?? '' ).trim().toLowerCase();
        if( normalized === 'y' ) {
          return true;
        }
        if( normalized === 'n' ) {
          return false;
        }
        return value;
      }
    },
    getVentilatorComment( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8229' );
    },
    getVentilatorCommentOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.ventilator_comment;
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 2400px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.secondarySpecification .afflo-ds-form-control) {
  width: 300px;
} 

:deep(.comments .afflo-ds-form-control) {
  width: 700px;
} 

:deep(.echoComment .afflo-ds-form-control) {
  width: 300px;
} 

:deep(.chestCTResults .afflo-ds-form-control) {
  width: 300px;
} 

.highlightField :deep(.afflo-ds-form-control) {
  border: 2px solid red;
}

</style>
